<y42-operation-input
  class="filter-input-as-ag-filter"
  [column]="column"
  [showRelativeDates]="true"
></y42-operation-input>
